'use client'

import { useTranslation } from '@/i18n/client'
import { Button } from 'antd'
import { buildAuthQueryParams } from 'components/auth/build.auth.query.params'
import { FeatureFlag } from 'components/feature/feature.flag'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import React, { FC } from 'react'

export const GotoRegister: FC = () => {
  const { t } = useTranslation()
  const searchParams = useSearchParams()

  return (
    <FeatureFlag
      name="register"
      active={
        <Link href={buildAuthQueryParams('/register', searchParams)} passHref>
          <Button size={'large'} type={'link'} block>
            {t('login-dont-have-account', 'Don\'t have an account?')}
          </Button>
        </Link>
      }
    />
  )
}
